export const homePageUrls: Record<string, string> = {
  getIssueTypes: "/taxonomy/issue-types",
  createIssue: "/job/create",
};
